export const proofingUrl = (
  merchflowId: number,
  runId: number | undefined,
  selected: number[],
  returnTo: string,
  isAllSelected = false,
) => {
  const params = new URLSearchParams({ merchflowId: String(merchflowId), returnTo });
  if (runId !== undefined) params.set("storePogTriggerId", String(runId));
  if (selected.length)
    params.set(isAllSelected ? "excludedStorePogIds" : "storePogIds", selected.join(","));
  return `/space-planning/review?${params}`;
};
export const proofingReturnUrl = (value: string | undefined, merchflowId: number | undefined) => {
  const fallback = merchflowId ? `/merchflows/${merchflowId}/stores/all` : "/space-planning";
  if (!value || !merchflowId) return fallback;
  try {
    const parsed = new URL(value, "http://localhost");
    return parsed.origin === "http://localhost" && parsed.pathname === fallback
      ? parsed.pathname + parsed.search
      : fallback;
  } catch {
    return fallback;
  }
};
